// @ts-nocheck
import { Box } from '@mui/material';
import { MBreadcrumbs, MHidden } from '../../components/@material-extend';
import { useBreadcrumbStore } from '../../stores/breadcrumb';

// ----------------------------------------------------------------------

export default function NavbarBreadcrumb() {
  const links = useBreadcrumbStore((state) => state.links);

  if (!links || links.length === 0) return null;

  return (
    <MHidden width="mdDown">
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, mr: 2 }}>
        <MBreadcrumbs
          links={links}
          sx={{
            '& .MuiBreadcrumbs-ol': { flexWrap: 'nowrap' },
            '& .MuiBreadcrumbs-li': { minWidth: 0 },
            '& a, & p': { fontSize: 13 },
          }}
        />
      </Box>
    </MHidden>
  );
}
